{
  "help": "Ajutor",
  "info": "Informaţii"
}
